<template>
  <div>
    <el-dialog
      :modal="true"
      class="logout-style"
      :visible.sync="isShowPopup"
      width="392px"
      :before-close="ok"
      center>
      <span class="log-msg-font-style">これ以上</span>
      <span class="log-msg-font-style">追加する事はできません</span>
      <br/>
      <span class="log-msg-font-style-min">「施設」「指定席」「備品」共に最大5件までです</span>
      <span class="log-msg-font-style-min">既にあるものを編集するか削除してください</span>
      <span slot="footer" class="log-msg-font-style">
        <sp-smart-button class="ok" @click="ok">{{ $t("button.common.ok") }}</sp-smart-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import SpSmartButton from "@/components/common/sp-smart-button"

export default {
  components:{
    SpSmartButton: SpSmartButton
  },
  data() {
    return {
    }
  },
  props: {
    isShowPopup: {
      type: Boolean,
      default: false
    },
  },
  mounted() {
  },
  methods:{
    ok () {
      this.$emit("update:isShowPopup", false)
    }
  }
};
</script>
<style scoped>
::v-deep .logout-style .el-dialog__header {
  display: none;

}
.log-msg-font-style {
  text-align: center;
  display: block;
  font-size: 24px;
}
.log-msg-font-style-min {
  text-align: center;
  display: block;
  font-size: 14px;
}
::v-deep .logout-style .el-dialog--center .el-dialog__footer {
  width: 464px !important;
  margin-top: 30px !important;
}

.ok{
  width: 290px !important;
  margin-left:-165px !important;
}
</style>
